
import Vue from "vue";
import { SaleRow } from "@/models/base";
import { SaleEditState } from "../../utils/sale-edit/sale-edit-state";
import AppSaleEditMobileEditRow from "./SaleEditMobileEditRow.vue";

export default Vue.extend({
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	computed: {
		addRowDisabled():boolean {
			return this.state.sale.Contact == null;
		},
		editRowOpened():boolean {
			if (this.state.productEditRowState.overrideMobileModalOpen){
				return true;
			}
			return this.state.sale.Rows.indexOf(this.state.selectedRow) != -1;
		}
	},
	watch: {
		"this.state.productEditRowState.toCreateProduct"(){
			if (this.state.productEditRowState.overrideMobileModalOpen){
				this.state.productEditRowState.overrideMobileModalOpen = true;
			}
		}
	},
	methods: {
		editRow(row:SaleRow) {
			this.state.selectedRow = row;
		},
		removeRow(i:number) {
			this.state.removeRow(i);
		},
		addRow() {
			this.state.productEditRowState.overrideMobileModalOpen = true;
			this.state.selectedRow = new SaleRow();
		},
		getDescription(description:string){
			let lines = this.state.getDisplayedRowProductDescription(description).split("<br>");
			let result:string[] = [];
			for (let i = 0; i < 2 && i < lines.length; i++){
				result.push(lines[i]);
			}
			return result.join("<br>");
		}
	},
	components: {
		AppSaleEditMobileEditRow,
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
